import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../api.js';
import AuthLayout from '../components/AuthLayout.jsx';
import Alert from '../components/ui/Alert.jsx';
import { Loading } from '../components/ui/index.jsx';

/**
 * Behind the link emailed to a person a company listed as sending on its behalf.
 * Opening it changes nothing; only a button decides. No account needed.
 */
export default function ConfirmSender() {
  const { token } = useParams();
  const [c, setC] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState('');

  useEffect(() => {
    api(`/public/sender-confirmations/${token}`).then((d) => setC(d.confirmation)).catch((err) => setError(err.message));
  }, [token]);

  const decide = async (decision) => {
    setBusy(decision); setError('');
    try { const res = await api(`/public/sender-confirmations/${token}`, { method: 'POST', body: { decision } }); setC(res.confirmation); }
    catch (err) { setError(err.message); }
    setBusy('');
  };

  if (error && !c) return <AuthLayout><h1>Confirm your address</h1><Alert tone="danger">{error}</Alert></AuthLayout>;
  if (!c) return <AuthLayout><Loading /></AuthLayout>;

  return (
    <AuthLayout onSubmit={(e) => e.preventDefault()}>
      <h1>{c.status === 'confirmed' ? 'Thank you — confirmed' : c.status === 'declined' ? 'Thank you — noted' : <>Do you send email for {c.organisation_name}?</>}</h1>
      {error && <Alert tone="danger">{error}</Alert>}
      {c.status === 'pending' && (
        <>
          <p>{c.requested_by ? <strong>{c.requested_by}</strong> : 'Someone'} at <strong>{c.organisation_name}</strong> has listed{' '}
            <strong className="mono">{c.email}</strong> as an address that sends email on {c.organisation_name}&rsquo;s behalf.</p>
          <p className="muted">When an attendee or exhibitor checks an email from this address, SummitShield will say it really comes from {c.organisation_name}.
            Your name is never shown to them.</p>
          <div className="decision-buttons">
            <button type="button" className="btn btn-primary btn-block" disabled={!!busy} onClick={() => decide('confirm')}>
              {busy === 'confirm' ? 'Confirming…' : `Yes, this is me`}
            </button>
            <button type="button" className="btn btn-secondary btn-block" disabled={!!busy} onClick={() => decide('decline')}>
              {busy === 'decline' ? 'Saving…' : 'This isn’t me'}
            </button>
          </div>
        </>
      )}
      {c.status === 'confirmed' && <Alert tone="success" title="Thank you — confirmed.">You can close this page.</Alert>}
      {c.status === 'declined' && <Alert tone="info" title="Thanks for letting us know.">Your address won&rsquo;t be treated as theirs. You can close this page.</Alert>}
      {['expired', 'cancelled', 'failed'].includes(c.status) && (
        <Alert tone="warn">
          {c.status === 'expired' ? 'This link has expired.' : c.status === 'failed' ? 'This request couldn’t be completed.' : 'This link has been replaced by a newer one.'}
          {' '}Nothing has changed.
        </Alert>
      )}
      <p className="muted small">SummitShield will never ask you for a password, a code or a payment on this page.</p>
    </AuthLayout>
  );
}
